export default __webpack_public_path__ + "static/media/freehold.b8de0a5a.PNG";